export const FAQ_REQUEST = "FAQ_REQUEST";
export const FAQ_SUCCESS = "FAQ_SUCCESS";
export const FAQ_FAILURE = "FAQ_FAILURE";